(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-text"] && !Shopify.designMode) return;
  try {
    

 var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i = 0; i < elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
                new TxtType(elements[i], JSON.parse(toRotate), period);
            }
            var borderColor = elements[i].getAttribute('data-cursor-color') || "#fff";
            var parent = elements[i].closest('section[id^="dynamic-"]');
            var styleId = 'typewrite-cursor-style-' + i;
            var css = document.createElement("style");
            css.id = styleId;
            var scope = parent ? ('#' + parent.id + ' ') : '';
            css.innerHTML = scope + ".typewrite > .wrap { border-right: 0.08em solid " + borderColor + "; }";
            document.head.appendChild(css);
        }
    };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sos-avis-google"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__sosGoogleReviewCarouselV1) return;
    window.__sosGoogleReviewCarouselV1 = true;
    const instances = new Map();
    const initialize = root => {
      if (instances.has(root)) return;
      const list = root.querySelector('.sos-reviews-grid');
      const navigation = root.querySelector('[data-reviews-navigation]');
      if (!list || !navigation) return;
      const cards = Array.from(list.querySelectorAll('.sos-reviews-card'));
      if (!cards.length) return;
      const controller = new AbortController();
      const options = {signal:controller.signal};
      const previous = navigation.querySelector('[data-reviews-previous]');
      const next = navigation.querySelector('[data-reviews-next]');
      list.id = root.id + '-carousel';
      list.tabIndex = 0;
      list.setAttribute('aria-label', 'Avis clients — défilement horizontal');
      previous.setAttribute('aria-controls', list.id);
      next.setAttribute('aria-controls', list.id);
      const bodies = Array.from(list.querySelectorAll('.sos-reviews-body')).map((text, index) => {
        text.setAttribute('data-collapsible', '');
        text.id = root.id + '-review-text-' + index;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sos-reviews-more';
        button.hidden = true;
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', text.id);
        const label = text.closest('.sos-reviews-reply') ? 'la réponse' : 'l’avis';
        button.textContent = 'Lire la suite de ' + label;
        text.after(button);
        button.addEventListener('click', () => {
          const expanded = text.toggleAttribute('data-expanded');
          button.setAttribute('aria-expanded', String(expanded));
          button.textContent = expanded ? 'Réduire ' + label : 'Lire la suite de ' + label;
        }, options);
        return {text,button};
      });
      let frame;
      const update = () => {
        const max = Math.max(0,list.scrollWidth - list.clientWidth);
        navigation.hidden = max < 3;
        previous.disabled = list.scrollLeft <= 6;
        next.disabled = list.scrollLeft >= max - 6;
        if (!list.clientWidth) return;
        bodies.forEach(({text,button}) => {
          if (!text.hasAttribute('data-expanded')) button.hidden = text.scrollHeight <= text.clientHeight + 2;
        });
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };
      const move = direction => {
        const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
        const step = cards[0].getBoundingClientRect().width + gap;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        list.scrollBy({left:direction * step,behavior});
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      list.addEventListener('scroll', schedule, options);
      list.addEventListener('keydown', event => {
        if (event.target !== list) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      const observer = new ResizeObserver(schedule);
      observer.observe(list);
      document.addEventListener('shopify:block:select', event => {
        const card = cards.find(card => card === event.target || card.contains(event.target));
        if (!card) return;
        list.scrollTo({left:list.scrollLeft + card.getBoundingClientRect().left - list.getBoundingClientRect().left - 4,behavior:'auto'});
      }, options);
      instances.set(root, () => {
        controller.abort();
        observer.disconnect();
        cancelAnimationFrame(frame);
        bodies.forEach(({text,button}) => {
          text.removeAttribute('data-collapsible');
          text.removeAttribute('data-expanded');
          button.remove();
        });
        navigation.hidden = true;
      });
      schedule();
      if (document.fonts) document.fonts.ready.then(() => {if (root.isConnected) schedule();});
    };
    const scan = scope => {
      if (scope.matches?.('.sos-reviews')) initialize(scope);
      scope.querySelectorAll('.sos-reviews').forEach(initialize);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
    else scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const [root,dispose] of instances) {
        if (event.target === root || event.target.contains(root)) {
          dispose();
          instances.delete(root);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sos-devis-sur-mesure"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.sq-form');
    const success = root.querySelector('.sq-success');
    if (success) { if (location.search.includes('contact_posted')) success.focus(); return; }
    if (!form) return;
    const steps = [...form.querySelectorAll('[data-step]')];
    if (steps.length !== 3) return;
    root.classList.add('sq-enhanced');
    const validation = form.querySelector('[data-validation]');
    const categories = [...form.querySelectorAll('[data-category]')];
    const method = form.querySelector('[data-method]');
    const phone = form.querySelector('[data-phone]');
    const timing = form.querySelector('[data-timing]');
    let current = 0;
    const show = (index, focus = true) => {
      current = index;
      steps.forEach((step, i) => { step.hidden = i !== index; });
      form.querySelectorAll('[data-progress]').forEach((item, i) => {
        item.classList.toggle('sq-complete', i < index);
        if (i === index) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
      });
      validation.hidden = true;
      if (index === 2) recap();
      if (focus) steps[index].querySelector('h2').focus({ preventScroll: true });
      if (focus) form.scrollIntoView({ behavior: 'instant', block: 'start' });
    };
    const syncCategory = () => {
      const selected = categories.find(radio => radio.checked)?.dataset.category;
      form.querySelectorAll('[data-conditional]').forEach(group => {
        const active = group.dataset.conditional === selected;
        group.hidden = !active;
        group.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !active; });
      });
    };
    const syncMethod = () => {
      const needsPhone = method.selectedOptions[0].dataset.methodKey !== 'email';
      phone.required = needsPhone;
      form.querySelector('[data-phone-star]').hidden = !needsPhone;
    };
    const recap = () => {
      const chosen = categories.find(radio => radio.checked);
      form.querySelector('[data-recap="category"]').textContent = chosen?.value || '—';
      form.querySelector('[data-recap="place"]').textContent = [form.querySelector('[data-city]').value, form.querySelector('[data-postcode]').value].filter(Boolean).join(' · ');
      form.querySelector('[data-recap="timing"]').textContent = timing.value;
    };
    const validStep = (index) => {
      const invalid = [...steps[index].querySelectorAll('input,select,textarea')].find(el => !el.disabled && !el.checkValidity());
      if (!invalid) return true;
      show(index);
      validation.hidden = false;
      invalid.focus();
      invalid.reportValidity();
      return false;
    };
    categories.forEach(radio => radio.addEventListener('change', syncCategory));
    method.addEventListener('change', syncMethod);
    timing.addEventListener('change', () => { form.querySelector('[data-urgent-note]').hidden = !timing.selectedOptions[0].hasAttribute('data-urgent'); });
    form.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => { if (validStep(current)) show(current + 1); }));
    form.querySelectorAll('[data-back]').forEach(button => button.addEventListener('click', () => show(Math.max(0, current - 1))));
    form.querySelector('[data-edit]').addEventListener('click', () => show(0));
    form.addEventListener('invalid', event => {
      const index = steps.findIndex(step => step.contains(event.target));
      if (index !== -1 && steps[index].hidden) show(index);
    }, true);
    form.addEventListener('submit', event => {
      for (let i = 0; i < 3; i++) { if (!validStep(i)) { event.preventDefault(); return; } }
      const submit = form.querySelector('[data-submit]');
      submit.setAttribute('aria-busy', 'true');
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT' && current < 2) { event.preventDefault(); if (validStep(current)) show(current + 1); }
    });
    const preset = new URLSearchParams(location.search).get('prestation');
    const matching = categories.find(radio => radio.dataset.category === preset);
    if (matching) matching.checked = true;
    syncCategory(); syncMethod(); show(0, false);
    window.addEventListener('pageshow', () => { form.querySelector('[data-submit]')?.removeAttribute('aria-busy'); });
  };
  const scan = () => document.querySelectorAll('.sq').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sos-services-categories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sos-service-categories')) {
    customElements.define('sos-service-categories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.index = 0;
        this.paused = false;
        this.removeAttribute('data-paused');
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-controls]').hidden = !this.panels.length;
        this.querySelector('[data-previous]').disabled = this.panels.length < 2;
        this.querySelector('[data-next]').disabled = this.panels.length < 2;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
        const pause = this.querySelector('[data-pause]');
        pause.setAttribute('aria-pressed', 'false');
        pause.setAttribute('aria-label', 'Mettre le défilement en pause');
        this.querySelector('[data-pause-icon]').textContent = 'Ⅱ';
        pause.addEventListener('click', () => {
          this.paused = !this.paused;
          this.toggleAttribute('data-paused', this.paused);
          pause.setAttribute('aria-pressed', String(this.paused));
          pause.setAttribute('aria-label', this.paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
          this.querySelector('[data-pause-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.show(index);
        }, options);
        this.observer = new ResizeObserver(() => this.schedule());
        this.observer.observe(this);
        this.panels.forEach(panel => this.observer.observe(panel.querySelector('[data-original]')));
        this.show(0);
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      }
      show(index) {
        if (!this.panels.length) return;
        this.index = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
        const counter = this.querySelector('[data-counter]');
        counter.textContent = (this.index + 1) + ' / ' + this.panels.length;
        const detail = document.createElement('span');
        detail.className = 'sos-cats-counter-detail';
        detail.textContent = ' — ' + this.panels[this.index].querySelector('[data-category-title]').textContent;
        counter.appendChild(detail);
        this.schedule();
      }
      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      }
      refresh() {
        const panel = this.panels[this.index];
        if (!panel || !this.isConnected) return;
        const track = panel.querySelector('[data-track]');
        track.removeAttribute('data-moving');
        track.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
        const original = track.querySelector('[data-original]');
        const width = original.getBoundingClientRect().width;
        const available = panel.querySelector('[data-viewport]').getBoundingClientRect().width;
        if (!original.children.length || width <= 0 || available <= 0) return;
        const copies = Math.ceil(available / width) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = original.cloneNode(true);
          clone.removeAttribute('data-original');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          track.appendChild(clone);
        }
        track.style.setProperty('--sos-cats-distance', width + 'px');
        void track.offsetWidth;
        track.setAttribute('data-moving', '');
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
